import React from 'react';
import { arrayOf, bool, object, string } from 'prop-types';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { connect } from 'react-redux';
import { CHECKOUT_PLANS } from '../../../utils/packagesUtils/constants';
import { translateTimeUnit } from '../../../utils/recurring/translation';
import { getRecurringOptions, getSelectedCheckoutPlan, getSelectedRecurringOption } from '../../../reducers/packages';

import './style.scss';

const RecurringOptionDiscount = ({
    recurringOptions,
    selectedCheckoutPlan,
    selectedRecurringOption,
    showShortDiscount = false,
    showOnSingleOrder = true
}) => {
    const { duration, durationTimeUnit, discountPercentage } = selectedRecurringOption;

    const isSingleOrder = selectedCheckoutPlan === CHECKOUT_PLANS.SINGLE_ORDER;
    const isSingleOption = recurringOptions.length === 1;
    const copySuffix = showShortDiscount ? 'short_discount' : 'discount';

    const getDiscountParams = () => ({
        percentage: discountPercentage,
        time_unit: translateTimeUnit(duration, durationTimeUnit)
    });

    const calculateShow = () => {
        const hasDiscount = discountPercentage > 0;

        return isSingleOrder
            ? hasDiscount && showOnSingleOrder
            : hasDiscount;
    };

    const show = calculateShow();

    const wrapperClass = classNames(
        'recurring-option-discount',
        'tbody-6',
        {
            'single-order': isSingleOrder,
            'single-option': isSingleOption
        }
    );

    if (!show) {return null;}

    return (
        <p className={wrapperClass}>
            <I18n k={`gig_page_perseus.recurring.${copySuffix}`}
                params={getDiscountParams()}/>
        </p>
    );
};

RecurringOptionDiscount.propTypes = {
    recurringOptions: arrayOf(object).isRequired,
    selectedCheckoutPlan: string.isRequired,
    selectedRecurringOption: object.isRequired,
    showShortDiscount: bool,
    showOnSingleOrder: bool
};

const mapStateToProps = ({ packages }) => {
    const recurringOptions = getRecurringOptions(packages);
    const selectedCheckoutPlan = getSelectedCheckoutPlan(packages);
    const selectedRecurringOption = getSelectedRecurringOption(packages);

    return {
        recurringOptions,
        selectedCheckoutPlan,
        selectedRecurringOption
    };
};

export { RecurringOptionDiscount };
export default connect(mapStateToProps)(RecurringOptionDiscount);
